document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.pfl-size-guide')) return;

    const finder = document.getElementById('size-finder');
    const sportLabels = Object.fromEntries(
      [...document.querySelectorAll('.finder-option')].map((item) => [
        item.dataset.finderSport,
        item.querySelector('strong')?.textContent.trim() || item.dataset.finderSport
      ])
    );
    const chartOptions = {
      baseball: [],
      soccer: [...document.querySelectorAll('[data-group="soccer"] .subtab')].map((item) => ({ id: item.dataset.sub.replace('soccer-', ''), label: item.textContent.trim() })),
      basketball: [...document.querySelectorAll('[data-group="basketball"] .subtab')].map((item) => ({ id: item.dataset.sub.replace('basketball-', ''), label: item.textContent.trim() })),
      football: [...document.querySelectorAll('[data-group="football"] .subtab')].map((item) => ({
        id: item.dataset.sub.replace('football-', ''),
        label: item.textContent.trim()
      })),
      hockey: [...document.querySelectorAll('[data-group="hockey"] .subtab')].map((item) => ({
        id: item.dataset.sub.replace('hockey-', ''),
        label: item.textContent.trim()
      }))
    };
    const validSports = Object.keys(chartOptions);
    let pendingSport = null;
    const sportStep = document.getElementById('finder-step-sport');
    const fitStep = document.getElementById('finder-step-fit');
    const fitOptions = document.getElementById('finder-fit-options');
    const selectionBar = document.getElementById('selection-bar');
    const selectionText = document.getElementById('selection-text');
    const returnProduct = document.getElementById('return-product');
    const resumeChoice = document.getElementById('resume-choice');

    function updateUrl(sport, fit, size) {
      const url = new URL(window.location.href);
      if (sport) url.searchParams.set('sport', sport);
      else url.searchParams.delete('sport');
      if (fit) url.searchParams.set('fit', fit);
      else url.searchParams.delete('fit');
      if (size) url.searchParams.set('size', size);
      else url.searchParams.delete('size');
      history.replaceState({}, '', url);
    }

    function showSport(sport) {
      document.querySelectorAll('.sport-tab').forEach((item) => {
        const active = item.dataset.sport === sport;
        item.classList.toggle('active', active);
        item.setAttribute('aria-selected', String(active));
      });
      document.querySelectorAll('.sport-panel').forEach((item) => {
        item.classList.toggle('active', item.id === sport);
      });
    }

    function showFit(sport, fit) {
      const panelId = `${sport}-${fit}`;
      const target = document.getElementById(panelId);
      if (!target) return null;
      const card = target.closest('.section-card');
      card.querySelectorAll('.subtab').forEach((item) => {
        item.classList.toggle('active', item.dataset.sub === panelId);
      });
      card.querySelectorAll('.subpanel').forEach((item) => {
        item.classList.toggle('active', item.id === panelId);
      });
      document.querySelectorAll(`[data-measure-sport="${sport}"] [data-measure-fit]`).forEach((item) => {
        const active = item.dataset.measureFit === fit;
        item.classList.toggle('active', active);
        item.hidden = !active;
      });
      return target;
    }

    function rememberSelection(sport, fit) {
      sessionStorage.setItem('pfl-size-chart', JSON.stringify({ sport, fit: fit || '' }));
    }

    function showSelection(sport, fit) {
      const fitLabel = chartOptions[sport].find((item) => item.id === fit)?.label;
      const baseLabel = fitLabel ? `${sportLabels[sport]} › ${fitLabel}` : `${sportLabels[sport]} › ${finder.dataset.allSizes}`;
      selectionText.dataset.base = baseLabel;
      selectionText.textContent = baseLabel;
      selectionBar.classList.add('visible');
    }

    function chartAnchor(sport, fit) {
      if (fit) return document.getElementById(`${sport}-${fit}`)?.closest('.section-card');
      const cards = document.getElementById(sport)?.querySelectorAll('.section-card');
      return cards && cards.length > 1 ? cards[1] : document.getElementById(sport);
    }

    function completeSelection(sport, fit, shouldScroll = true) {
      showSport(sport);
      if (fit) showFit(sport, fit);
      showSelection(sport, fit);
      rememberSelection(sport, fit);
      updateUrl(sport, fit, '');
      sportStep.hidden = false;
      fitStep.hidden = true;
      document.getElementById('progress-one').classList.add('active');
      document.getElementById('progress-two').classList.add('active');
      document.getElementById('progress-line').classList.add('active');
      if (shouldScroll) {
        window.setTimeout(() => chartAnchor(sport, fit)?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 80);
      }
    }

    function openFitStep(sport) {
      pendingSport = sport;
      document.querySelectorAll('.finder-option').forEach((item) => {
        item.classList.toggle('selected', item.dataset.finderSport === sport);
      });
      fitOptions.innerHTML = chartOptions[sport].map((fit) =>
        `<button class="finder-fit" type="button" data-fit="${fit.id}">${fit.label}</button>`
      ).join('');
      document.getElementById('fit-question').textContent = finder.dataset.fitQuestion.replace('{sport}', sportLabels[sport].toLowerCase());
      sportStep.hidden = true;
      fitStep.hidden = false;
      document.getElementById('progress-two').classList.add('active');
      document.getElementById('progress-line').classList.add('active');
      fitOptions.querySelectorAll('.finder-fit').forEach((button) => {
        button.addEventListener('click', () => completeSelection(sport, button.dataset.fit));
      });
    }

    document.querySelectorAll('.finder-option').forEach((button) => {
      button.addEventListener('click', () => {
        const sport = button.dataset.finderSport;
        if (sport === 'baseball') completeSelection('baseball', '');
        else openFitStep(sport);
      });
    });

    document.getElementById('finder-back').addEventListener('click', () => {
      pendingSport = null;
      sportStep.hidden = false;
      fitStep.hidden = true;
      document.getElementById('progress-two').classList.remove('active');
      document.getElementById('progress-line').classList.remove('active');
    });

    document.getElementById('change-selection').addEventListener('click', () => {
      selectionBar.classList.remove('visible');
      sportStep.hidden = false;
      fitStep.hidden = true;
      finder.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    document.getElementById('copy-chart-link').addEventListener('click', async (event) => {
      await navigator.clipboard.writeText(window.location.href);
      const originalLabel = event.currentTarget.textContent;
      event.currentTarget.textContent = finder.dataset.copiedLabel;
      window.setTimeout(() => { event.currentTarget.textContent = originalLabel; }, 1600);
    });

    document.querySelectorAll('.sport-tab').forEach((button) => {
      button.addEventListener('click', () => {
        const sport = button.dataset.sport;
        if (sport === 'soccer') {
          const fit = document.querySelector('[data-group="soccer"] .subtab.active')?.dataset.sub.replace('soccer-', '') || 'short_men';
          completeSelection(sport, fit, false);
          return;
        }
        if (sport === 'basketball') {
          const fit = document.querySelector('[data-group="basketball"] .subtab.active')?.dataset.sub.replace('basketball-', '') || 'adult';
          completeSelection(sport, fit, false);
          return;
        }
        showSport(sport);
        selectionBar.classList.remove('visible');
        updateUrl(sport, '', '');
      });
    });

    document.querySelectorAll('.subtabs').forEach((group) => {
      group.querySelectorAll('.subtab').forEach((button) => {
        button.addEventListener('click', () => {
          const [sport, fit] = button.dataset.sub.split('-');
          showSport(sport);
          showFit(sport, fit);
          showSelection(sport, fit);
          rememberSelection(sport, fit);
          updateUrl(sport, fit, '');
        });
      });
    });

    document.querySelectorAll('tbody tr').forEach((row) => {
      row.setAttribute('tabindex', '0');
      const selectRow = () => {
        const table = row.closest('table');
        table.querySelectorAll('tbody tr').forEach((item) => item.classList.remove('selected'));
        row.classList.add('selected');
        const size = row.cells[0]?.textContent.trim();
        const url = new URL(window.location.href);
        const sport = url.searchParams.get('sport');
        const fit = url.searchParams.get('fit');
        if (sport) {
          updateUrl(sport, fit, size);
          selectionText.textContent = `${selectionText.dataset.base || sportLabels[sport]} • ${size}`;
        }
      };
      row.addEventListener('click', selectRow);
      row.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectRow();
        }
      });
    });

    const initialUrl = new URL(window.location.href);
    const initialSport = initialUrl.searchParams.get('sport');
    const initialFit = initialUrl.searchParams.get('fit') || (initialSport === 'basketball' ? 'adult' : initialSport === 'soccer' ? 'short_men' : '');
    const initialSize = initialUrl.searchParams.get('size');
    const returnUrl = initialUrl.searchParams.get('return');
    if (returnUrl) {
      returnProduct.href = returnUrl;
      returnProduct.textContent = finder.dataset.backProductLabel;
    }

    if (validSports.includes(initialSport)) {
      const validFit = chartOptions[initialSport].some((item) => item.id === initialFit);
      completeSelection(initialSport, validFit ? initialFit : '', false);
      if (initialSize) {
        const activePanel = initialFit ? document.getElementById(`${initialSport}-${initialFit}`) : document.getElementById(initialSport);
        const matchingRow = [...(activePanel?.querySelectorAll('tbody tr') || [])].find((row) => row.cells[0]?.textContent.trim() === initialSize);
        matchingRow?.classList.add('selected');
        selectionText.textContent = `${selectionText.dataset.base} • ${initialSize}`;
        updateUrl(initialSport, validFit ? initialFit : '', initialSize);
      }
      window.setTimeout(() => chartAnchor(initialSport, validFit ? initialFit : '')?.scrollIntoView({ block: 'start' }), 120);
    } else {
      try {
        const recent = JSON.parse(sessionStorage.getItem('pfl-size-chart'));
        if (recent && validSports.includes(recent.sport)) {
          const fitLabel = chartOptions[recent.sport].find((item) => item.id === recent.fit)?.label;
          resumeChoice.textContent = `${finder.dataset.continueLabel} ${sportLabels[recent.sport]}${fitLabel ? ` › ${fitLabel}` : ''} →`;
          resumeChoice.classList.add('visible');
          resumeChoice.addEventListener('click', () => completeSelection(recent.sport, recent.fit));
        }
      } catch (error) {
        sessionStorage.removeItem('pfl-size-chart');
      }
    }
  
});
